






















































import Component from 'vue-class-component'
import Vue from 'vue'

import eventModule from '@/store/event'
import dealModule from '@/store/deal'
import DealBookmarkCard from '@/components/deal/DealBookmarkCard.vue'
import { CategoryType } from '@/utils/enums'
import { Bookmark, Deal } from '../types/Deal'

@Component({
  name: 'FavoritesView',
  components: {
    DealBookmarkCard
  }
})
class FavoritesView extends Vue {
  private bookmarks: Bookmark[] = []

  private hasNoBookmarks = false

  private get loading() {
    return eventModule.loading
  }

  private get localBookmarks(): Bookmark[] {
    return this.bookmarks.filter(
      bookmark => bookmark.deal.type === CategoryType.LOCAL
    )
  }

  private async openDeal(currentDeal: Deal): Promise<void> {
    await dealModule.setDeal(currentDeal)
    this.$router.push({
      name: 'DealDetail',
      params: { id: currentDeal._id }
    })
  }

  private get onlineBookmarks(): Bookmark[] {
    return this.bookmarks.filter(
      bookmark => bookmark.deal.type === CategoryType.ONLINE
    )
  }

  private async created(): Promise<void> {
    eventModule.setLoading(true)
    await dealModule.fetchBookmarks()
    eventModule.setLoading(false)

    this.bookmarks = dealModule.bookmarks
    this.hasNoBookmarks = this.bookmarks.length === 0
  }
}

export default FavoritesView
